module.exports = __webpack_public_path__ + "img/phone_icon.ea262c93.png";